/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationPricingsSelfWorkerQuery = gql`
  query GetSimulationPricingsSelfWorkerQuery {
    getSimulationPricingsSelfWorker_simulation_pricings_self_worker {
      guarantees {
 code  
nodeType  
parentCode  
label  
legend  
selected  
editable  
recommended  
recommendedMessages  
value  
valueType  
unit  
base  
options {
 code  
nodeType  
parentCode  
label  
legend  
selected  
editable  
recommended  
recommendedMessages  
value  
valueType  
unit  
base  
options {
 code  
nodeType  
parentCode  
label  
legend  
selected  
editable  
recommended  
recommendedMessages  
value  
valueType  
unit  
base  
options {
 code  
nodeType  
parentCode  
label  
legend  
selected  
editable  
recommended  
recommendedMessages  
value  
valueType  
unit  
base  
options {
 code  
nodeType  
parentCode  
label  
legend  
selected  
editable  
recommended  
recommendedMessages  
value  
valueType  
unit  
base  
options {
 code  
nodeType  
parentCode  
label  
legend  
selected  
editable  
recommended  
recommendedMessages  
value  
valueType  
unit  
base  
ruleset  
RO  
healthInsurance  
labelsRO  
contributions {
 code  
defaultAmount  
} 
} 
ruleset  
RO  
healthInsurance  
labelsRO  
contributions {
 code  
defaultAmount  
} 
} 
ruleset  
RO  
healthInsurance  
labelsRO  
contributions {
 code  
defaultAmount  
} 
} 
ruleset  
RO  
healthInsurance  
labelsRO  
contributions {
 code  
defaultAmount  
} 
} 
ruleset  
RO  
healthInsurance  
labelsRO  
contributions {
 code  
defaultAmount  
} 
} 
ruleset  
RO  
healthInsurance  
labelsRO  
contributions {
 code  
defaultAmount  
} 
}
      grantees {
 type  
birthDate  
externalId  
}
      minBirthDateReducChild 
      maxBirthDateReducChild 
      minBirthDateHospiChild 
      maxBirthDateHospiChild 
      customerCSPCategory 
      commission {
 type  
rate  
}
      annualIncome 
      PASS 
    }
  }
`;

export default GetSimulationPricingsSelfWorkerQuery;
